import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { forwardRef } from 'react';
import { c as classNames } from '../../shared/index-324f55b0.js';
import { getTestId } from '../../utils/testId.js';
import { getSizingClassName, getSizingStyle } from '../../utils/sizing.js';
import { getPaddingClasses } from '../../utils/padding.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "stack--p-none": "web_ui__Stack__stack--p-none",
  "stack--pt-none": "web_ui__Stack__stack--pt-none",
  "stack--pr-none": "web_ui__Stack__stack--pr-none",
  "stack--pb-none": "web_ui__Stack__stack--pb-none",
  "stack--pl-none": "web_ui__Stack__stack--pl-none",
  "stack--px-none": "web_ui__Stack__stack--px-none",
  "stack--py-none": "web_ui__Stack__stack--py-none",
  "stack--p-x-small": "web_ui__Stack__stack--p-x-small",
  "stack--pt-x-small": "web_ui__Stack__stack--pt-x-small",
  "stack--pr-x-small": "web_ui__Stack__stack--pr-x-small",
  "stack--pb-x-small": "web_ui__Stack__stack--pb-x-small",
  "stack--pl-x-small": "web_ui__Stack__stack--pl-x-small",
  "stack--px-x-small": "web_ui__Stack__stack--px-x-small",
  "stack--py-x-small": "web_ui__Stack__stack--py-x-small",
  "stack--p-small": "web_ui__Stack__stack--p-small",
  "stack--pt-small": "web_ui__Stack__stack--pt-small",
  "stack--pr-small": "web_ui__Stack__stack--pr-small",
  "stack--pb-small": "web_ui__Stack__stack--pb-small",
  "stack--pl-small": "web_ui__Stack__stack--pl-small",
  "stack--px-small": "web_ui__Stack__stack--px-small",
  "stack--py-small": "web_ui__Stack__stack--py-small",
  "stack--p-regular": "web_ui__Stack__stack--p-regular",
  "stack--pt-regular": "web_ui__Stack__stack--pt-regular",
  "stack--pr-regular": "web_ui__Stack__stack--pr-regular",
  "stack--pb-regular": "web_ui__Stack__stack--pb-regular",
  "stack--pl-regular": "web_ui__Stack__stack--pl-regular",
  "stack--px-regular": "web_ui__Stack__stack--px-regular",
  "stack--py-regular": "web_ui__Stack__stack--py-regular",
  "stack--p-medium": "web_ui__Stack__stack--p-medium",
  "stack--pt-medium": "web_ui__Stack__stack--pt-medium",
  "stack--pr-medium": "web_ui__Stack__stack--pr-medium",
  "stack--pb-medium": "web_ui__Stack__stack--pb-medium",
  "stack--pl-medium": "web_ui__Stack__stack--pl-medium",
  "stack--px-medium": "web_ui__Stack__stack--px-medium",
  "stack--py-medium": "web_ui__Stack__stack--py-medium",
  "stack--p-large": "web_ui__Stack__stack--p-large",
  "stack--pt-large": "web_ui__Stack__stack--pt-large",
  "stack--pr-large": "web_ui__Stack__stack--pr-large",
  "stack--pb-large": "web_ui__Stack__stack--pb-large",
  "stack--pl-large": "web_ui__Stack__stack--pl-large",
  "stack--px-large": "web_ui__Stack__stack--px-large",
  "stack--py-large": "web_ui__Stack__stack--py-large",
  "stack--p-larger": "web_ui__Stack__stack--p-larger",
  "stack--pt-larger": "web_ui__Stack__stack--pt-larger",
  "stack--pr-larger": "web_ui__Stack__stack--pr-larger",
  "stack--pb-larger": "web_ui__Stack__stack--pb-larger",
  "stack--pl-larger": "web_ui__Stack__stack--pl-larger",
  "stack--px-larger": "web_ui__Stack__stack--px-larger",
  "stack--py-larger": "web_ui__Stack__stack--py-larger",
  "stack--p-x-large": "web_ui__Stack__stack--p-x-large",
  "stack--pt-x-large": "web_ui__Stack__stack--pt-x-large",
  "stack--pr-x-large": "web_ui__Stack__stack--pr-x-large",
  "stack--pb-x-large": "web_ui__Stack__stack--pb-x-large",
  "stack--pl-x-large": "web_ui__Stack__stack--pl-x-large",
  "stack--px-x-large": "web_ui__Stack__stack--px-x-large",
  "stack--py-x-large": "web_ui__Stack__stack--py-x-large",
  "stack--p-x-larger": "web_ui__Stack__stack--p-x-larger",
  "stack--pt-x-larger": "web_ui__Stack__stack--pt-x-larger",
  "stack--pr-x-larger": "web_ui__Stack__stack--pr-x-larger",
  "stack--pb-x-larger": "web_ui__Stack__stack--pb-x-larger",
  "stack--pl-x-larger": "web_ui__Stack__stack--pl-x-larger",
  "stack--px-x-larger": "web_ui__Stack__stack--px-x-larger",
  "stack--py-x-larger": "web_ui__Stack__stack--py-x-larger",
  "stack--p-x2-large": "web_ui__Stack__stack--p-x2-large",
  "stack--pt-x2-large": "web_ui__Stack__stack--pt-x2-large",
  "stack--pr-x2-large": "web_ui__Stack__stack--pr-x2-large",
  "stack--pb-x2-large": "web_ui__Stack__stack--pb-x2-large",
  "stack--pl-x2-large": "web_ui__Stack__stack--pl-x2-large",
  "stack--px-x2-large": "web_ui__Stack__stack--px-x2-large",
  "stack--py-x2-large": "web_ui__Stack__stack--py-x2-large",
  "stack": "web_ui__Stack__stack",
  "width-parent": "web_ui__Stack__width-parent",
  "width-content": "web_ui__Stack__width-content",
  "width-custom": "web_ui__Stack__width-custom",
  "height-parent": "web_ui__Stack__height-parent",
  "height-content": "web_ui__Stack__height-content",
  "height-custom": "web_ui__Stack__height-custom",
  "scroll": "web_ui__Stack__scroll",
  "horizontal": "web_ui__Stack__horizontal",
  "fill-equally": "web_ui__Stack__fill-equally",
  "vertical": "web_ui__Stack__vertical",
  "wrap": "web_ui__Stack__wrap",
  "stack--gap-none": "web_ui__Stack__stack--gap-none",
  "stack--gap-x-small": "web_ui__Stack__stack--gap-x-small",
  "stack--gap-small": "web_ui__Stack__stack--gap-small",
  "stack--gap-regular": "web_ui__Stack__stack--gap-regular",
  "stack--gap-medium": "web_ui__Stack__stack--gap-medium",
  "stack--gap-large": "web_ui__Stack__stack--gap-large",
  "stack--gap-larger": "web_ui__Stack__stack--gap-larger",
  "stack--gap-x-large": "web_ui__Stack__stack--gap-x-large",
  "stack--gap-x-larger": "web_ui__Stack__stack--gap-x-larger",
  "stack--gap-x2-large": "web_ui__Stack__stack--gap-x2-large",
  "stack--justify-center": "web_ui__Stack__stack--justify-center",
  "stack--justify-end": "web_ui__Stack__stack--justify-end",
  "stack--justify-start": "web_ui__Stack__stack--justify-start",
  "stack--justify-space-in-between": "web_ui__Stack__stack--justify-space-in-between",
  "stack--justify-space-around": "web_ui__Stack__stack--justify-space-around",
  "stack--justify-space-evenly": "web_ui__Stack__stack--justify-space-evenly",
  "stack--align-center": "web_ui__Stack__stack--align-center",
  "stack--align-top": "web_ui__Stack__stack--align-top",
  "stack--align-bottom": "web_ui__Stack__stack--align-bottom",
  "stack--align-baseline": "web_ui__Stack__stack--align-baseline"
};

var Stack = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'parent' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'parent' : _ref$width,
    scroll = _ref.scroll,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction,
    _ref$distribution = _ref.distribution,
    distribution = _ref$distribution === void 0 ? 'start' : _ref$distribution,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'top' : _ref$alignment,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 'none' : _ref$gap,
    _ref$wrap = _ref.wrap,
    wrap = _ref$wrap === void 0 ? false : _ref$wrap,
    _ref$fillEqually = _ref.fillEqually,
    fillEqually = _ref$fillEqually === void 0 ? false : _ref$fillEqually,
    padding = _ref.padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingHorizontal = _ref.paddingHorizontal,
    paddingVertical = _ref.paddingVertical,
    testId = _ref.testId;
  var sizingClass = getSizingClassName(styles, width, height);
  var style = getSizingStyle('stack', width, height);
  var paddingClass = getPaddingClasses(styles, 'stack', {
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingX: paddingHorizontal,
    paddingY: paddingVertical
  });
  var stackClass = classNames(sizingClass, paddingClass, [styles["stack--justify-".concat(distribution)]], [styles["stack--align-".concat(alignment)]], [styles["stack--gap-".concat(gap)]], fillEqually && [[styles['fill-equally']]], wrap && [[styles.wrap]], scroll && [[styles.scroll]]);
  var finalClass = classNames(styles.stack, stackClass, _defineProperty(_defineProperty({}, styles.horizontal, direction === 'row'), styles.vertical, direction === 'column'));
  return /*#__PURE__*/jsx(Component, {
    className: finalClass,
    ref: ref,
    "data-testid": getTestId(testId, 'parent'),
    style: style,
    children: children
  });
});
Stack.displayName = 'Stack';

export { Stack as default };
//# sourceMappingURL=Stack.js.map
